import { makeStyles } from "@fluentui/react-components";
import { primer } from "./primerDarkTheme";

export const useProjectPickerStyles = makeStyles({
    page: {
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: primer.canvas,
        color: primer.fg,
        overflow: "hidden",
    },
    body: {
        flex: "1",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: 0,
        overflowY: "auto" as const,
        paddingTop: "40px",
        paddingBottom: "40px",
    },
    mainContent: {
        width: "100%",
        maxWidth: "1000px",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
    },
    titleText: {
        fontSize: "24px",
        fontWeight: 700,
        color: primer.fg,
        whiteSpace: "nowrap" as const,
    },
    titleSpacer: { flex: "1" },
    refreshBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 12px",
        fontSize: "14px",
        fontWeight: 500,
        color: primer.fg,
        backgroundColor: primer.surface,
        border: `1px solid ${primer.border}`,
        borderRadius: "6px",
        cursor: "pointer",
        whiteSpace: "nowrap" as const,
        "&:hover": { backgroundColor: primer.overlay },
    },
    tableSection: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
    },
    workspaceLabel: {
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        fontSize: "12px",
        fontWeight: 400,
        color: primer.fg,
    },
    workspaceDropdownWrapper: {
        position: "relative" as const,
    },
    workspaceDropdownBtn: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        height: "32px",
        padding: "0 12px",
        fontSize: "14px",
        fontWeight: 400,
        color: primer.fg,
        backgroundColor: primer.surface,
        border: `1px solid ${primer.border}`,
        borderRadius: "6px",
        cursor: "pointer",
        minWidth: "220px",
        "&:hover": { backgroundColor: primer.overlay },
        "&:disabled": { cursor: "default", "&:hover": { backgroundColor: primer.surface } },
    },
    workspaceDropdownMenu: {
        position: "absolute" as const,
        top: "36px",
        left: 0,
        minWidth: "280px",
        backgroundColor: primer.surface,
        border: `1px solid ${primer.border}`,
        borderRadius: "8px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
        zIndex: 50,
        padding: "4px 0",
        maxHeight: "300px",
        overflowY: "auto" as const,
    },
    workspaceDropdownSearch: {
        display: "block",
        width: "calc(100% - 16px)",
        margin: "4px 8px 6px",
        padding: "6px 10px",
        fontSize: "13px",
        color: primer.fg,
        backgroundColor: primer.canvas,
        border: `1px solid ${primer.border}`,
        borderRadius: "4px",
        outline: "none",
        "&::placeholder": { color: primer.fgSubtle },
        "&:focus": { borderColor: primer.blue as unknown as never },
    },
    workspaceDropdownItem: {
        display: "block",
        width: "100%",
        padding: "8px 14px",
        fontSize: "13px",
        fontWeight: 400,
        color: primer.fg,
        backgroundColor: "transparent",
        border: "none",
        textAlign: "left" as const,
        cursor: "pointer",
        "&:hover": { backgroundColor: primer.overlay },
    },
    workspaceDropdownItemActive: {
        fontWeight: 600,
        color: primer.blue,
        backgroundColor: primer.overlay,
    },
    projectCount: {
        fontSize: "13px",
        color: primer.fgMuted,
    },
    searchInput: {
        marginLeft: "auto",
        height: "28px",
        width: "300px",
        padding: "4px 10px",
        fontSize: "13px",
        borderRadius: "6px",
        border: `1px solid ${primer.border}`,
        backgroundColor: primer.canvas,
        color: primer.fg,
        outline: "none",
        "&::placeholder": { color: primer.fgSubtle },
        "&:focus": { borderColor: primer.blue as unknown as never },
    },
    tableWrapper: {
        backgroundColor: primer.surface,
        border: `1px solid ${primer.border}`,
        borderRadius: "8px",
        overflow: "hidden",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse" as const,
        fontSize: "14px",
    },
    thead: {},
    th: {
        padding: "10px 20px",
        fontWeight: 600,
        fontSize: "12px",
        color: primer.fgMuted,
        textAlign: "left" as const,
        backgroundColor: primer.overlay,
    },
    thAction: {
        padding: "10px 20px",
        backgroundColor: primer.overlay,
        width: "80px",
    },
    tr: {
        borderTop: `1px solid ${primer.borderMuted}`,
        "&:hover": { backgroundColor: primer.overlay },
    },
    td: {
        padding: "14px 20px",
        color: primer.fg,
        fontSize: "14px",
        fontWeight: 600,
    },
    tdMuted: {
        padding: "14px 20px",
        color: primer.fgMuted,
        fontSize: "13px",
        fontWeight: 400,
    },
    tdAction: {
        padding: "14px 20px",
        textAlign: "right" as const,
    },
    openBtn: {
        padding: "4px 12px",
        fontSize: "12px",
        fontWeight: 500,
        border: `1px solid ${primer.blue}`,
        borderRadius: "6px",
        backgroundColor: "transparent",
        color: primer.blue,
        cursor: "pointer",
        "&:hover": { backgroundColor: "rgba(56,139,253,0.15)" },
    },
    loading: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 0",
        color: primer.fgMuted,
        fontSize: "14px",
    },
    error: {
        color: primer.redText,
        fontSize: "14px",
        padding: "12px 0",
    },
    emptyTable: {
        textAlign: "center" as const,
        padding: "48px 0",
        color: primer.fgMuted,
        fontSize: "14px",
    },
});
